import React, { useEffect } from "react";
import { Box, Grid, MenuItem, Typography } from "@mui/material";
import ButtonComp from "../../../../components/Button";
import Input from "../../../../components/Input";
import theme from "../../../../theme";
import { useState } from "react";
import { getFleetBranches } from "../../../../services/dashboard";

export default function DriverDetails({ setStep, formData, setFormData }: any) {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [fleetBranches, setFleetBranches] = useState<any[]>([]);

  useEffect(() => {
    const loadBranches = async () => {
      const response = await getFleetBranches();
      if (response?.status === 200 && Array.isArray(response.data)) {
        setFleetBranches(
          response.data.sort((a: any, b: any) =>
            String(a.branchName || "").localeCompare(String(b.branchName || "")),
          ),
        );
      }
    };

    void loadBranches();
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "branchId") {
      const selectedBranch = fleetBranches.find(
        (branch: any) => String(branch.id) === String(value),
      );
      setFormData({
        ...formData,
        branchId: value,
        branchLocation: selectedBranch?.branchName || "",
      });
      setErrors((prev: any) => ({
        ...prev,
        branch: "",
        branchId: "",
      }));
      return;
    }
    setFormData({ ...formData, [name]: value });
    setErrors((prev: any) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateStep1 = () => {
    let newErrors: any = {};

    if (!formData.firstName) newErrors.firstName = "First name is required";
    if (!formData.lastName) newErrors.lastName = "Last name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phoneNumber)
      newErrors.contactNumber = "Phone number is required";
    if (!formData.licenseCode)
      newErrors.licenseCode = "License code is required";
    if (!formData.residentialAddress) newErrors.address = "Address is required";
    if (!formData.workShift) newErrors.workShift = "Work shift is required";
    if (!formData.branchId) newErrors.branch = "Branch is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.licenseIssueDate)
      newErrors.licenseIssueDate = "Issue date is required";
    if (!formData.licenseExpiryDate)
      newErrors.licenseExpiryDate = "Expiry date is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (!validateStep1()) return;
    setStep(2);
  };

  return (
    <Box>
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.primary.main,
          fontSize: { xs: "28px", md: "38px" },
          fontWeight: 600,
          mb: 3,
          textAlign: "center",
        }}
      >
        Driver's Details
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Input
            fullWidth
            label="First Name"
            name="firstName"
            variant="outlined"
            value={formData.firstName}
            onChange={handleChange}
            error={!!errors.firstName}
            helperText={errors.firstName}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            fullWidth
            label="Last Name"
            name="lastName"
            variant="outlined"
            value={formData.lastName}
            onChange={handleChange}
            error={!!errors.lastName}
            helperText={errors.lastName}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            fullWidth
            label="Email"
            name="email"
            variant="outlined"
            value={formData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
          />
        </Grid>
      
        <Grid size={{ xs: 6 }}>
          <Input
            select
            label="Gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            error={!!errors.gender}
            helperText={errors.gender}
          >
            <MenuItem value="MALE">Male</MenuItem>
            <MenuItem value="FEMALE">Female</MenuItem>
          </Input>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            fullWidth
            label="Mobile"
            name="phoneNumber"
            variant="outlined"
            value={formData.phoneNumber}
            onChange={handleChange}
            error={!!errors.contactNumber}
            helperText={errors.contactNumber}
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <Input
            fullWidth
            label="Address"
            name="residentialAddress"
            variant="outlined"
            value={formData.residentialAddress}
            onChange={handleChange}
            error={!!errors.address}
            helperText={errors.address}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            select
            label="License Code"
            name="licenseCode"
            value={formData.licenseCode}
            onChange={handleChange}
            error={!!errors.licenseCode}
            helperText={errors.licenseCode}
          >
            <MenuItem value="CODE_8">Code 8</MenuItem>
            <MenuItem value="CODE_10">Code 10</MenuItem>
            <MenuItem value="CODE_14">Code 14</MenuItem>
          </Input>
        </Grid>

        <Grid size={{ xs: 6 }}>
          <Input
            select
            label="Work Shift"
            name="workShift"
            value={formData.workShift}
            onChange={handleChange}
            error={!!errors.workShift}
            helperText={errors.workShift}
          >
            <MenuItem value="MORNING_SHIFT">Morning Shift</MenuItem>
            <MenuItem value="MID_DAY_SHIFT">Mid-day Shift</MenuItem>
            <MenuItem value="NIGHT_SHIFT">Night Shift</MenuItem>
          </Input>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            select
            label="Vehicle Type"
            name="assignedVehicleType"
            value={formData.assignedVehicleType}
            onChange={handleChange}
          >
            <MenuItem value="HEARSE">Hearse</MenuItem>
            <MenuItem value="FAMILY_CAR">Family Car</MenuItem>
            <MenuItem value="UTILITY_VEHICLE">Utility Vehicle</MenuItem>
          </Input>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            select
            label="Branch"
            name="branchId"
            value={formData.branchId}
            onChange={handleChange}
            error={!!errors.branch}
            helperText={errors.branch}
          >
            <MenuItem value="">Select branch</MenuItem>
            {fleetBranches.map((branch: any) => (
              <MenuItem key={branch.id} value={branch.id}>
                {branch.branchName}
                {branch.province ? ` - ${branch.province}` : ""}
              </MenuItem>
            ))}
          </Input>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            type="date"
            label="License Issue Date"
            name="licenseIssueDate"
            value={formData.licenseIssueDate}
            onChange={handleChange}
            error={!!errors.licenseIssueDate}
            helperText={errors.licenseIssueDate}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Input
            type="date"
            label="License Expiry Date"
            name="licenseExpiryDate"
            value={formData.licenseExpiryDate}
            onChange={handleChange}
            error={!!errors.licenseExpiryDate}
            helperText={errors.licenseExpiryDate}
          />
        </Grid>
      </Grid>

      {/* Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 5,
        }}
      >
        <ButtonComp
          variant="contained"
          height={40}
          width={190}
          onClick={handleNext}
        >
          Next
        </ButtonComp>
      </Box>
    </Box>
  );
}
